
document.addEventListener('DOMContentLoaded', function() {
    let headers = document.querySelectorAll('#footer h2');

    function toggleClassOnClick() {
        if (window.innerWidth < 768) {
            headers.forEach(function (header) {
                header.addEventListener('click', toggleOpenClass);
            });
        } else {
            headers.forEach(function (header) {
                header.removeEventListener('click', toggleOpenClass);
                header.classList.remove('open');
                if (header.nextElementSibling) {
                    header.nextElementSibling.classList.remove('open');
                }
            });
        }
    }

    function toggleOpenClass() {
        let siblingUl = this.nextElementSibling;
        this.classList.toggle('open');
        siblingUl.classList.toggle('open');
    }

    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Initial check
    toggleClassOnClick();

    // Add resize event listener with debounce
    window.addEventListener('resize', debounce(toggleClassOnClick, 200));
});